<template>
  <b-nav class="gmb-account-menu" id="nav" pills>
    <!-- <b-nav-item href="/" class="" link-classes="p-1 gmb-account-menu__item-link"
      >Home</b-nav-item
    > -->
    <b-nav-item
        class="ml-2 gmb-account-menu__item"
        link-classes="p-2 rounded-1 gmb-account-menu__item-link"
        @click="openModal('observatory-credential-manager')"
    >
      <div class="m-2 row no-gutters">
        <div class="d-flex col align-items-center">
          <FdText fa>
            <i class="fas fa-key"/>
          </FdText>
          <FdText class="ml-1" fontSizeSmaller2 minContent tag="span" uppercase
          >Comptes&nbsp;rattachés
          </FdText
          >
        </div>
      </div>
    </b-nav-item>
    <b-nav-item-dropdown
        class="ml-2"
        menu-class="mt-3 border-0 py-2 px-0 rounded-1 gmb-account-menu__dropdown"
        no-caret
        right
        toggle-class="p-2 rounded-1 gmb-account-menu__item-link"
    >
      <template #button-content>
        <div class="m-2 row no-gutters">
          <div class="d-flex col align-items-center">
            <FdText fa>
              <i class="fas fa-user"/>
            </FdText>
            <FdText
                class="mx-1"
                fontSizeSmaller2
                minContent
                tag="span"
                uppercase
            >
              {{ userAccount ? userAccount.username : "Utilisateur" }}
            </FdText>
            <i class="fas fa-caret-down"/>
          </div>
        </div>
      </template>

      <b-dropdown-item-button
          button-class="py-2 px-5 rounded-1 gmb-account-menu__item-link"
          class=""
          to="/logout"
          @click="onLogout"
      >
        <FdText tag="span">Déconnecter</FdText>
      </b-dropdown-item-button>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import ModalEventBus from "@/modalEventBus.js";
import router from "@/router";
import {logout} from "@/services/authentication";

import FdText from "@/flexdesign/Text";

export default {
  name: "GmbAccountMenu",

  components: {
    FdText,
  },

  props: {
    userAccount: Object,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onLogout() {
      logout().finally(() => {
        router.push("/authentication/");
      });
    },

    openModal(modalSlug) {
      ModalEventBus.$emit("gmb-open-modal", modalSlug);
    },
  },
};
</script>

<style lang="scss"></style>
